import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { FlexboxProps, PaddingProps, shadow, ShadowProps } from 'styled-system';
import { Flex } from '../containers/Flex/Flex.component';

const StyledContainer = styled(Flex)<ShadowProps>`
  background-color: ${({ theme }) => theme.header.backgroundColor};
  min-height: 50px;
  position: relative;
  box-shadow: ${({ boxShadow, theme }) => (boxShadow === 'line' ? theme.shadows.line : undefined)};
  ${shadow}
`;

export interface IHeaderProps extends FlexboxProps, PaddingProps {
  shadow?: 'none' | 'small' | 'large' | 'line';
  subject?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  borderBottom?: boolean; // TODO: check if real
  fullWidth?: boolean; // TODO: check if real
}

export const Header: FunctionComponent<IHeaderProps> = ({ children, shadow = 'line', ...props }) => (
  <StyledContainer boxShadow={shadow} flexShrink={0} {...props}>
    {children}
  </StyledContainer>
);

Header.displayName = 'Header';
